import React from 'react'
import styles from './Overlay.module.scss'

export function Overlay(props) {
	return (
		<div
			onClick={(e) => e.stopPropagation()}
			className={styles.root}
			{...props}
			style={{ opacity: props.overlayOpacity }}
		>
			{props.children}
		</div>
	)
}
